import { useCallback, useRef, type ReactNode } from 'react';
import { Button } from '../../components/ui/button';
import { cn } from '../../lib/utils';

export function useVideoTriggerFocus() {
  const openerRef = useRef<HTMLElement | null>(null);
  const rememberOpener = useCallback((el: HTMLElement) => {
    openerRef.current = el;
  }, []);
  const restoreFocus = useCallback((event: Event) => {
    const opener = openerRef.current;
    openerRef.current = null;
    if (!opener?.isConnected) return;
    event.preventDefault();
    opener.focus();
  }, []);
  return { rememberOpener, restoreFocus };
}

export function LiveVideoTrigger({
  label,
  onOpen,
  className,
  children,
}: {
  label: string;
  onOpen: (trigger: HTMLElement) => void;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      aria-label={label}
      onClick={(e) => onOpen(e.currentTarget)}
      className={cn(
        'h-auto justify-start gap-3 rounded-lg p-0 text-left font-normal whitespace-normal hover:bg-transparent dark:hover:bg-transparent',
        className,
      )}
    >
      {children}
    </Button>
  );
}
